// Action Creators
import { ActionCreator } from "@ms/planner-actioncreators/lib/local/actioncreators/ActionCreator";
import { Store } from "@ms/planner-stores/lib/local/stores/Store";
import { SubRouteType } from "@ms/uno-constants/lib/local/RoutingConstants";
import { StoreEntityState } from "@ms/uno-constants/lib/local/StoreConstants";
// Utilities
import { extractBasicPlanRoutingDetailsFromSubRoute } from "@ms/uno-routing";
import { Worker } from "../Worker";
/**
 * Worker responsible for ensuring data integrity
 */ export class DataIntegrityWorker {
    get name() {
        return Worker.DataIntegrity;
    }
    init() {
        this.storeSubscriptionManager.registerSubscription([
            Store.Route,
            Store.Bucket,
            Store.Goal,
            Store.CustomFieldDefinition
        ], this.onTrigger);
    }
    stop() {
        this.storeSubscriptionManager.unregisterSubscription([
            Store.Route,
            Store.Bucket,
            Store.Goal,
            Store.CustomFieldDefinition
        ], this.onTrigger);
    }
    /**
     * Constructor for the DataIntegrityWorker
     * @param acLoader The action creator loader
     * @param storeLoader The store loader
     * @param storeSubscriptionManager The store subscription manager
     * @param configProvider The config provider
     */ constructor(acLoader, storeLoader, storeSubscriptionManager, configProvider){
        this.acLoader = acLoader;
        this.storeLoader = storeLoader;
        this.storeSubscriptionManager = storeSubscriptionManager;
        this.configProvider = configProvider;
        this.onTrigger = ()=>{
            const [routeStore, bucketStore, goalStore] = this.storeLoader.loadAll([
                Store.Route,
                Store.Bucket,
                Store.Goal
            ]);
            const subRouteType = routeStore.getCurrentSubRouteType();
            const subRoute = routeStore.getCurrentSubRoute();
            switch(subRouteType){
                case SubRouteType.BasicPlan:
                    const planId = extractBasicPlanRoutingDetailsFromSubRoute(subRoute)?.planId;
                    if (planId) {
                        const bucketsForPlanResult = bucketStore.getBucketsForPlan(planId);
                        if (bucketsForPlanResult.status.state === StoreEntityState.Present) {
                            this.acLoader.load(ActionCreator.DataIntegrity).reportValidBuckets(planId, bucketsForPlanResult.data);
                        }
                        const goalsForPlanResult = goalStore.getGoalsForPlan(planId);
                        if (goalsForPlanResult.status.state === StoreEntityState.Present) {
                            this.acLoader.load(ActionCreator.DataIntegrity).reportValidGoals(planId, goalsForPlanResult.data);
                        }
                        if (this.configProvider().flights.EnableCustomFields) {
                            const customFieldDefinitionStore = this.storeLoader.load(Store.CustomFieldDefinition);
                            const cfdsForPlanResult = customFieldDefinitionStore.getCustomFieldDefinitionsForPlan(planId);
                            if (cfdsForPlanResult.status.state === StoreEntityState.Present) {
                                this.acLoader.load(ActionCreator.DataIntegrity).reportValidCustomFieldDefinitions(planId, cfdsForPlanResult.data);
                            }
                        }
                    }
                    break;
                default:
            }
        };
    }
}
